import { default as _91_46_46_46slug_9370ctdIMJ0ZMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/[...slug].vue?macro=true";
import { default as indexCjw1Rf6e66Meta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/auth/index.vue?macro=true";
import { default as indexzJuOpusXCfMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93EVDJpTAbwmMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93YmGW1Mq6tkMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93CfhLabCXvaMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93tN2sqq4sxFMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/news/[slug].vue?macro=true";
import { default as organisationsLtAAUgLG8OMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventsXyECE6M2V1Meta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programsUbPNvYsxYzMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as indextqVN6uJyPYMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/processes/index.vue?macro=true";
import { default as dungeonwdPOWeNVZyMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsNpnq0GbJWsMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexvDJYJvgSsyMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/secret/index.vue?macro=true";
import { default as indexXzdbUuTma4Meta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseData4h2GdDv2dzMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassFhSxaYQj0YMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93xiCXRK59myMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexsTG6sc9bS8Meta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDataE38x7GnTMUMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFieldsLHivnSHLAjMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReportsT5eeG9KmZrMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRightsiWH98xx1nrMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93k6XqyPmCmMMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as indexysMVl3j4ScMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitieseITgaidxHTMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDataJBkRyH3r3pMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93r6CcfCHlEjMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as index2xBEusmm6tMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesxRTQih49gRMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDataLXzW9BznTJMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93lPDOKlCobIMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexOlcMEgW4x3Meta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDataflCQUE7KkGMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93PER0yS1TNEMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexyBEv4utXIIMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseData0iUrueNFUIMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClassy9RhlLkPkUMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedFormsfl79HRWs9DMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_93rdKOg83qTpMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as indexOS0hCvonSnMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitiesgEPApZMb0PMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseDataoEUcHuO7TTMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriods7nbULzkeWUMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as _91id_93NLY5gStQwtMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as indexqfheIExxpOMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivitiesB0tmJjtyicMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDataPN7L4QEYY5Meta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotifications6rvBHkQGnZMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93d0hATHumS3Meta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexdM9uTI9CWNMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDatazi4OuOiNSEMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDatajMbBzfoRLgMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_93vPWhClbF18Meta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as index6NnqjdN7lMMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDatadBlRthpC0KMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93mHSnWqr2gKMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexWT5jgFC4aFMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroupsiBRts4q2YNMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDataAiJPNZnO0aMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_93hp0jHL2Hc4Meta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as indexpvie4jCdagMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parishesHbAgV1veEUMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitiestyWYAwWkRtMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupsC44wncDMQQMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDataDuARbbjm8yMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconias6SAWV72vmUMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishesFbMXEJzK05Meta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93rdCgVSxeY3Meta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as indexN6Z5I9aK4YMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regions2cyWpiOWfYMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehltmn7Z6wAtRIMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunBaseDatabN7WUkuorDMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsgNA20XMIk4Meta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93aBjhzj1GW6Meta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as index7HzZB7h6lzMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as paymentsk2CR1BZDZ2Meta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/payments.vue?macro=true";
import { default as processActivitiesqXvB8Os6AIMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseData8LFPCF5teFMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93U9nirZleWZMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/processes/[id].vue?macro=true";
import { default as indexwdQQUEt3qUMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/processes/index.vue?macro=true";
import { default as _91id_93WF3eCGD5IiMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexrnD3bSgKvdMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProviders6EaWrkXOy7Meta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesuIB71pzdjAMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingsqyGpk6kLqXMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDataOZCgP8wGhjMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesPO3zaVlk0GMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConceptnpCMlTz0OcMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreementQ5yBelhW2WMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersU7zDgHKpHnMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_938xkkenS9nGMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexS8mS1m6NHMMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisationskNjWuSr8TkMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivities6OvqpR5M3VMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseData3E1NNB9GmRMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignaturefwTD1tiKkBMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93vskjtrnpQhMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexythDskxz0LMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/users/index.vue?macro=true";
import { default as usersTrKpzz4aE8Meta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/users.vue?macro=true";
import { default as settingsZ5wEMGLRYiMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivitiesp4udu693bHMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseDataeutLqswRRPMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_93x3ObgqqcHHMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as indexXBykrWgyGrMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as serviceiwSz2G3BG5Meta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service.vue?macro=true";
import { default as languageMD7f1WBkdIMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseData7rME6RCn9MMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesISkiogo4FAMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreementveh1nKqpwHMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsers6J7RdTCONjMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_935uLId9WRxwMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDatawL8LBmD2mAMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignaturejJaiUJyaDlMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93TQTJ26PCXBMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/users/[id].vue?macro=true";
import { default as indexRv6jrNClQBMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/users/index.vue?macro=true";
import { default as settingsyxZbVPZ0cjMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings.vue?macro=true";
import { default as signatureGIDooC89ScMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/signature.vue?macro=true";
import { default as _91id_93JWDJ1otzJoMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_93J1FwqIAZKWMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as indexOgEvrT3uybMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46slug_93Ca7slBczvCMeta } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/wiki/[...slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_9370ctdIMJ0ZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexCjw1Rf6e66Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexzJuOpusXCfMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93EVDJpTAbwmMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93YmGW1Mq6tkMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93CfhLabCXvaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsLtAAUgLG8OMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indextqVN6uJyPYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: serviceiwSz2G3BG5Meta?.name,
    path: "/service",
    meta: serviceiwSz2G3BG5Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDatadBlRthpC0KMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexXzdbUuTma4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93xiCXRK59myMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexsTG6sc9bS8Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93k6XqyPmCmMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: indexysMVl3j4ScMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93r6CcfCHlEjMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: index2xBEusmm6tMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93lPDOKlCobIMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexOlcMEgW4x3Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93PER0yS1TNEMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexyBEv4utXIIMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_93rdKOg83qTpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: indexOS0hCvonSnMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_93NLY5gStQwtMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: indexqfheIExxpOMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93d0hATHumS3Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotifications6rvBHkQGnZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexdM9uTI9CWNMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93vPWhClbF18Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: index6NnqjdN7lMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93mHSnWqr2gKMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parishesHbAgV1veEUMeta?.name,
    path: "parishes",
    meta: parishesHbAgV1veEUMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_93hp0jHL2Hc4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regions2cyWpiOWfYMeta?.name,
    path: "regions",
    meta: regions2cyWpiOWfYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93rdCgVSxeY3Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: paymentsk2CR1BZDZ2Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93aBjhzj1GW6Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: index7HzZB7h6lzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93U9nirZleWZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexwdQQUEt3qUMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/processes/index.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingsZ5wEMGLRYiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProviders6EaWrkXOy7Meta?.name,
    path: "loginProviders",
    meta: loginProviders6EaWrkXOy7Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93WF3eCGD5IiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexrnD3bSgKvdMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisationskNjWuSr8TkMeta?.name,
    path: "organisations",
    meta: organisationskNjWuSr8TkMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_938xkkenS9nGMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexS8mS1m6NHMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: usersTrKpzz4aE8Meta?.name,
    path: "users",
    meta: usersTrKpzz4aE8Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93vskjtrnpQhMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexythDskxz0LMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_93x3ObgqqcHHMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: indexXBykrWgyGrMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/service/statisticProcesses/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsyxZbVPZ0cjMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_935uLId9WRxwMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93TQTJ26PCXBMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: indexRv6jrNClQBMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signatureGIDooC89ScMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/signature.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93JWDJ1otzJoMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_93J1FwqIAZKWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexOgEvrT3uybMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/statistics/index.vue")
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93Ca7slBczvCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250417144722/client/pages/wiki/[...slug].vue")
  }
]